import {formatDate} from 'mc/lib/utils/commons';
import * as subjektFormatter from 'mc/lib/utils/subjektFormatter';
import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import {formatCurrencyWithoutSymbol} from '../../utils/popUtils';
import DataTable from '../datatable/DataTable';
import ZadostActionsMenu from './ZadostActionsMenu';
import ZadostStavLabel from './ZadostStavLabel';

const {ColumnType, ColumnAlignment} = DataTable;

export default class ZadostTable extends PureComponent {

    static propTypes = {
        rows: PropTypes.array.isRequired,
        visibleColumnNames: PropTypes.array,
        headerOnly: PropTypes.bool,
        bodyOnly: PropTypes.bool,
    };

    constructor(props) {
        super(props);

        this.columns = [
            {
                name: "vs",
                label: "VS",
            },
            {
                name: "castka",
                label: "Částka zadosti",
                format: formatCurrencyWithoutSymbol,
                alignment: ColumnAlignment.RIGHT,
            },
            {
                name: "preplatek",
                label: "Přeplatek",
                format: formatCurrencyWithoutSymbol,
                alignment: ColumnAlignment.RIGHT,
            }, {
                name: "nedoplatek",
                label: "Zbývá zaplatit",
                format: formatCurrencyWithoutSymbol,
                alignment: ColumnAlignment.RIGHT,
            },
            {
                name: "drzitel",
                label: "Držitel",
                format: subjektFormatter.getUplnyNazev,
            },
            {
                name: "cislo",
                label: "Číslo žádosti",
            },
            {
                name: "datumPodani",
                label: "Datum podání",
                format: formatDate,
            },
            {
                name: "datumUhrazeni",
                label: "Datum uhrazení",
                format: formatDate,
            },
            {
                name: "stav",
                label: "Stav žádosti",
                component: ZadostStavLabel,
            },
            {
                name: "actions",
                type: ColumnType.ACTIONS,
                component: this.renderActions,
            }
        ];
    }

    renderActions = ({row}) => {
        return <ZadostActionsMenu zadost={row}/>;
    };

    render() {
        const {rows, visibleColumnNames, headerOnly, bodyOnly} = this.props;
        return <DataTable columns={this.columns}
                          visibleColumnNames={visibleColumnNames}
                          rows={rows}
                          headerOnly={headerOnly}
                          bodyOnly={bodyOnly}
                          bodyProps={{className: "items-list"}}
                          bodyRowProps={{className: "card-block actions-hover"}}
                          striped
                          hover
                          bordered/>;
    }

}
